/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {viewWebShortlink} from '../api'

export const useMutationViewWebShortlink = createReactQueryMutationHook('viewWebShortlink', viewWebShortlink)
